module.exports = __webpack_public_path__ + "static/media/AT.de35e4d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/AT.svg
// module id = 193
// module chunks = 0